// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Button, Table } from "antd";
// import {
//   Avatar_06,
//   Avatar_07,
//   Avatar_14,
//   Avatar_18,
//   Avatar_19,
//   Avatar_22,
//   Avatar_26,
//   Avatar_29,
// } from "../../../Routes/ImagePath";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
// import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
// import SearchBox from "../../../components/SearchBox";
// import Breadcrumbs from "../../../components/Breadcrumbs";
// import ClientsFilter from "../../../components/ClientsFilter";
// import ChannelPartnerFilter from "./ChannelPartnerFilter";
// import { ChannelPartnerModal } from "./ChannelPartnerModal";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import ChannelpartnerDeleteModal from "../../../components/modelpopup/ChannelpartnerDeleteModal";
// import moment from "moment";

// const ChannelpartnerList = () => {
//   // const data = [
//   //   {
//   //     id: 1,
//   //     Name: "Carlson Tech",
//   //     ClientId: "CLT-0008",
//   //     ContactPerson: "Betty Carlson",
//   //     Email: "bettycarlson@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-danger",
//   //     Status: "Inactive",
//   //     Image: Avatar_22,
//   //   },
//   //   {
//   //     id: 2,
//   //     Name: "Cream Inc",
//   //     ClientId: "CLT-0003",
//   //     ContactPerson: "Ruby Bartlett",
//   //     Email: "rubybartlett@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_07,
//   //   },
//   //   {
//   //     id: 3,
//   //     Name: "Delta Infotech",
//   //     ClientId: "CLT-0002",
//   //     ContactPerson: "Tressa Wexler",
//   //     Email: "tressawexler@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-danger",
//   //     Status: "Inactive",
//   //     Image: Avatar_29,
//   //   },
//   //   {
//   //     id: 4,
//   //     Name: "Global Technologies",
//   //     ClientId: "CLT-0001",
//   //     ContactPerson: "Barry Cuda",
//   //     Email: "barrycuda@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_19,
//   //   },
//   //   {
//   //     id: 5,
//   //     Name: "International Software Inc",
//   //     ClientId: "CLT-0006",
//   //     ContactPerson: "Walter Weaver",
//   //     Email: "walterweaver@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_18,
//   //   },
//   //   {
//   //     id: 6,
//   //     Name: "Mercury Software Inc",
//   //     ClientId: "CLT-0007",
//   //     ContactPerson: "Amanda Warren",
//   //     Email: "amandawarren@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_26,
//   //   },
//   //   {
//   //     id: 7,
//   //     Name: "Mustang Technologies",
//   //     ClientId: "CLT-0005",
//   //     ContactPerson: "Daniel Deacon",
//   //     Email: "danieldeacon@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_14,
//   //   },
//   //   {
//   //     id: 8,
//   //     Name: "Wellware Company",
//   //     ClientId: "CLT-0004",
//   //     ContactPerson: "Misty Tison",
//   //     Email: "mistytison@example.com",
//   //     Mobile: "9876543210",
//   //     Class: "fa-regular fa-circle-dot text-success",
//   //     Status: "Active",
//   //     Image: Avatar_06,
//   //   },
//   // ];

//   const [data,setData] = useState([])

//   const ChannelPartnerDataFetch =async () => {
//     try {
//       const userId = JSON.parse(sessionStorage.getItem('user'))?.id
//       const response = await axios.get(`${Api_Url}api/v1/ChannelPartner?UserId=${userId}&PageNumber=1&PageSize=100`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user'))?.accessToken}`
//         }
//       })
//       console.log(response.data?.data)
//       setData(response?.data?.data)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(()=> {
// ChannelPartnerDataFetch()
//   },[])

//   const [deleteId,setDeleteId] = useState(null)
//   const channelPartnerDeleteFunction=async () => {
//     try {
//       const response = await axios.delete(`${Api_Url}api/v1/ChannelPartner/${deleteId}`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       ChannelPartnerDataFetch()
//     } catch (error) {
//       return error.message
//     }
//   }

//   const columns = [
//     {
//       title: "Name",
//       dataIndex: "name",
//       render: (text, record) => (
//         <span className="table-avatar">
//           <Link to="/profile" className="avatar">
//             <img alt="" src={record.selfieUrl} />
//           </Link>
//           <Link to="/profile">{text}</Link>
//         </span>
//       ),
//     },
//     {
//       title: "Branch Name",
//       dataIndex: "branchName",
//     },

//     {
//       title: "Mobile",
//       dataIndex: "mobile",
//     },
//     {
//       title: "Last Activity",
//       dataIndex: "",
//       render: (text, record) => (
//         <span className="table-avatar">
//           {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
//         </span>
//       ),
//     },

//     {
//       title: "Location",
//       dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
//       render: (text, record) => (
//         <a
//           href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <i class="fa-solid fa-location-dot"></i>
//         </a>
//       )},
//    ]

//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content container-fluid">
//           {/* Page Header */}
//           <div className="page-header">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <h3 className="page-title">Channel Partner Visit</h3>
//                 <ul className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/dashboard">Dashboard</Link>
//                   </li>
//                   <li className="breadcrumb-item active">Channel Partner Visit</li>
//                 </ul>
//               </div>
//               <div className="col-md-8 float-end ms-auto">
//                 <div className="d-flex title-head">
//                   <div className="view-icons">
//                     <div className="form-sort">
//                       <Link to="#" className="list-view btn btn-link">
//                         <i className="las la-file-export" />
//                         Export
//                       </Link>
//                     </div>
//                   </div>
//                   <Breadcrumbs
//                    modal="#add_client"
//                    name="Add Channel Partner"
//                    Linkname="/clients"
//                    Linkname1="/clients-list"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//           <ChannelPartnerFilter />
//           <div className="row">
//             <div className="col-md-12">
//               <div className="table-responsive">
//                 <SearchBox />
//                 <Table
//                   className="table-striped"
//                   style={{ overflowX: "auto" }}
//                   columns={columns}
//                   dataSource={data}
//                   rowKey={(record) => record.id}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <ChannelPartnerModal ChannelPartnerVisitDataFetch ={ChannelPartnerDataFetch} />
//       <ChannelpartnerDeleteModal Name="Delete Client" ChannelPartnerDeleteFunction= {channelPartnerDeleteFunction}/>
//     </>
//   );
// };

// export default ChannelpartnerList;

// Modal

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table } from "antd";
import {
  Avatar_06,
  Avatar_07,
  Avatar_14,
  Avatar_18,
  Avatar_19,
  Avatar_22,
  Avatar_26,
  Avatar_29,
} from "../../../Routes/ImagePath";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
import SearchBox from "../../../components/SearchBox";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ClientsFilter from "../../../components/ClientsFilter";
import ChannelPartnerFilter from "./ChannelPartnerFilter";
import { ChannelPartnerModal } from "./ChannelPartnerModal";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import ChannelpartnerDeleteModal from "../../../components/modelpopup/ChannelpartnerDeleteModal";
import moment from "moment";

const ChannelpartnerList = () => {
  // const data = [
  //   {
  //     id: 1,
  //     Name: "Carlson Tech",
  //     ClientId: "CLT-0008",
  //     ContactPerson: "Betty Carlson",
  //     Email: "bettycarlson@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-danger",
  //     Status: "Inactive",
  //     Image: Avatar_22,
  //   },
  //   {
  //     id: 2,
  //     Name: "Cream Inc",
  //     ClientId: "CLT-0003",
  //     ContactPerson: "Ruby Bartlett",
  //     Email: "rubybartlett@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-success",
  //     Status: "Active",
  //     Image: Avatar_07,
  //   },
  //   {
  //     id: 3,
  //     Name: "Delta Infotech",
  //     ClientId: "CLT-0002",
  //     ContactPerson: "Tressa Wexler",
  //     Email: "tressawexler@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-danger",
  //     Status: "Inactive",
  //     Image: Avatar_29,
  //   },
  //   {
  //     id: 4,
  //     Name: "Global Technologies",
  //     ClientId: "CLT-0001",
  //     ContactPerson: "Barry Cuda",
  //     Email: "barrycuda@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-success",
  //     Status: "Active",
  //     Image: Avatar_19,
  //   },
  //   {
  //     id: 5,
  //     Name: "International Software Inc",
  //     ClientId: "CLT-0006",
  //     ContactPerson: "Walter Weaver",
  //     Email: "walterweaver@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-success",
  //     Status: "Active",
  //     Image: Avatar_18,
  //   },
  //   {
  //     id: 6,
  //     Name: "Mercury Software Inc",
  //     ClientId: "CLT-0007",
  //     ContactPerson: "Amanda Warren",
  //     Email: "amandawarren@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-success",
  //     Status: "Active",
  //     Image: Avatar_26,
  //   },
  //   {
  //     id: 7,
  //     Name: "Mustang Technologies",
  //     ClientId: "CLT-0005",
  //     ContactPerson: "Daniel Deacon",
  //     Email: "danieldeacon@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-success",
  //     Status: "Active",
  //     Image: Avatar_14,
  //   },
  //   {
  //     id: 8,
  //     Name: "Wellware Company",
  //     ClientId: "CLT-0004",
  //     ContactPerson: "Misty Tison",
  //     Email: "mistytison@example.com",
  //     Mobile: "9876543210",
  //     Class: "fa-regular fa-circle-dot text-success",
  //     Status: "Active",
  //     Image: Avatar_06,
  //   },
  // ];

  const [data, setData] = useState([]);

  const ChannelPartnerDataFetch = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/ChannelPartner?UserId=${userId}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      console.log(response.data?.data);
      setData(response?.data?.data);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    ChannelPartnerDataFetch();
  }, []);

  const [deleteId, setDeleteId] = useState(null);
  const channelPartnerDeleteFunction = async () => {
    try {
      const response = await axios.delete(
        `${Api_Url}api/v1/ChannelPartner/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      ChannelPartnerDataFetch();
    } catch (error) {
      return error.message;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.selfieUrl} />
          </Link>
          <Link to="/profile">{text}</Link>
        </span>
      ),
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },

    {
      title: "Mobile",
      dataIndex: "mobile",
    },
    {
      title: "Last Activity",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },

    {
      title: "Location",
      dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
      render: (text, record) => (
        <a
          href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-location-dot"></i>
        </a>
      ),
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">Channel Partner Visit</h3>
              <div>
                <button className="btn border me-3">
                  <Link to="#" className="list-view btn btn-link">
                    <i className="las la-file-export" />
                    Export
                  </Link>
                </button>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={handleOpenModal}
                >
                  Add Channel Partner Visit
                </button>
                {isModalOpen && (
                  <ChannelPartnerModal
                    onClose={handleCloseModal}
                    ChannelPartnerVisitDataFetch={ChannelPartnerDataFetch}
                  />
                )}
              </div>
            </div>
          </div>
          {/* <ChannelPartnerFilter /> */}
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <ChannelPartnerModal ChannelPartnerVisitDataFetch ={ChannelPartnerDataFetch} /> */}
      <ChannelpartnerDeleteModal
        Name="Delete Client"
        ChannelPartnerDeleteFunction={channelPartnerDeleteFunction}
      />
    </>
  );
};

export default ChannelpartnerList;
